import IconHOC from '../IconHOC';
import { ReactComponent as ActivityIcon } from './activity.svg';

export const Activity = IconHOC(ActivityIcon);
